import 'select2'

var selectOptions = {
  width: '100%',
  theme: "bootstrap-5"
}

// Remove Bootstrap 5 focus enforcement in modals (allows select2 to work in modals)
const originalEnforceFocus = bootstrap.Modal.prototype._enforceFocus
bootstrap.Modal.prototype._enforceFocus = function() {}

document.addEventListener('initialize', function() {
  $('select.webinar_participant').select2({
    width: '100%',
    theme: "bootstrap-5",
    minimumInputLength: 3,
    ajax: {
      url: $('.selectpicker.webinar_participant').data("url"),
      contentType: "application/json",
      dataType: 'json',
      data: function (params) {
        return { search: params.term }
      },
      processResults: function (data) {
        return { results: data.results }
      }
    }
  })

  $('select:not(#selected_id):not(.webinar_participant):not(.update-cost-data)').select2(selectOptions)
});

document.addEventListener("turbo:before-cache", function() {
  $("select.select2-hidden-accessible").select2('destroy')
})

$(document).on('select2:select', function (e) {
  let event = new Event('change', { bubbles: true })
  e.target.dispatchEvent(event)
})

$(document).on('.only-one-per-group select2:selecting', function(event) {
  $(event.target).find("option[value='" + event.params.args.data.id + "']").parent().children().prop('selected', false)
  $(event.target).select2('destroy').select2(selectOptions);
})
